// canvasPreviewClick — pure helper deciding whether an empty-canvas click
// should clear the workflow-node preview frame.
//
// Pulled out of EditorCanvasSli so the click logic can be unit-tested without
// mounting the full canvas (which pulls in interact.js, plugin registry, etc.).
// The render path imports this and calls it from the Col's onClick handler.
//
// Rules:
//   * No preview active        -> never clear (return false).
//   * Modifier key held        -> never clear (preserves multi-select gestures).
//   * Click landed on a box    -> never clear (EditorBox.onClick already stops
//                                  propagation; this is defense in depth in
//                                  case stopPropagation regresses).
//   * Click landed elsewhere   -> clear.
//
// "On a box" is detected by walking up the DOM looking for an element whose
// id starts with "box-" — the marker EditorBox.jsx writes at render time.
export function shouldClearPreviewOnCanvasClick(event, previewFrame) {
  if (previewFrame == null) return false;
  if (!event) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey) return false;
  const target = event.target;
  if (target && typeof target.closest === "function" && target.closest('[id^="box-"]')) {
    return false;
  }
  return true;
}
